<template>
  <aside class="mobile-app-banner" role="region" :aria-label="$t('mobile_app_banner_title')">
    <img class="mobile-app-banner__icon" src="/images/favicon.png" alt="" aria-hidden="true">

    <div class="mobile-app-banner__copy">
      <strong>{{ $t('mobile_app_banner_title') }}</strong>
      <span>{{ $t('mobile_app_banner_message', { platform: platformName }) }}</span>
    </div>

    <a class="mobile-app-banner__action" :href="storeUrl">
      <AppIcon :name="platformIcon" :class="platformIcon" aria-hidden="true" />
      <span>{{ $t('download') }}</span>
    </a>

    <button
      type="button"
      class="mobile-app-banner__close"
      :aria-label="$t('close')"
      :title="$t('close')"
      @click="$emit('dismiss')"
    >
      <AppIcon name="bi-x-lg" class="bi bi-x-lg" aria-hidden="true" />
    </button>
  </aside>
</template>

<script>
const STORE_URLS = {
  android: 'https://play.google.com/store/apps/details?id=com.gstocky.app',
  ios: 'https://apps.apple.com/fr/app/gstocky/id6812928113'
}

export default {
  name: 'MobileAppBanner',
  props: {
    platform: {
      type: String,
      required: true,
      validator: value => ['android', 'ios'].includes(value)
    }
  },
  computed: {
    storeUrl() {
      return STORE_URLS[this.platform]
    },
    platformName() {
      return this.platform === 'android' ? 'Android' : 'iOS'
    },
    platformIcon() {
      return this.platform === 'android' ? 'bi bi-google-play' : 'bi bi-apple'
    }
  }
}
</script>

<style scoped>
.mobile-app-banner {
  position: fixed;
  top: 64px;
  right: 0;
  left: 0;
  z-index: 147;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.5rem 0.65rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: linear-gradient(135deg, #003f93, #0068d9);
  box-shadow: 0 5px 16px rgba(0, 49, 115, 0.2);
  color: #fff;
}

.mobile-app-banner__icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
}

.mobile-app-banner__copy {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.mobile-app-banner__copy strong {
  overflow: hidden;
  font-size: 0.78rem;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-app-banner__copy span {
  overflow: hidden;
  margin-top: 0.16rem;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.67rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-app-banner__action {
  min-height: 36px;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.4rem 0.65rem;
  border-radius: 9px;
  background: #fff;
  color: #004aad;
  font-size: 0.72rem;
  font-weight: 750;
  text-decoration: none;
}

.mobile-app-banner__action:focus-visible {
  outline: 3px solid rgba(255, 255, 255, 0.45);
  outline-offset: 2px;
}

.mobile-app-banner__close {
  width: 34px;
  height: 34px;
  min-height: 34px !important;
  flex: 0 0 34px;
  padding: 0 !important;
  border: 0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.mobile-app-banner__close:hover,
.mobile-app-banner__close:focus-visible {
  background: rgba(255, 255, 255, 0.22);
  outline: none;
}

@media (min-width: 992px) {
  .mobile-app-banner {
    display: none;
  }
}

@media (max-width: 359.98px) {
  .mobile-app-banner__action span {
    display: none;
  }

  .mobile-app-banner__action {
    width: 36px;
    padding-inline: 0;
  }
}
</style>
